import { combineReducers } from "redux";

import homebanner from "../features/admin/homepage/homebanner/Slice";
import everyspace from "../features/admin/homepage/everyspace/Slice";
import howwework from "../features/admin/homepage/how_we_work/Slice";
import homeabout from "../features/admin/homepage/home_about/Slice";
import counter from "../features/admin/homepage/counter/Slice";

import common from "../features/admin/common/Slice";

const homepage = combineReducers({
    homebanner,
    everyspace,
    howwework,
    homeabout,
    counter,
    common
});

export default homepage;